import React from 'react';
import { View } from 'react-native';
import Text from '@/components/Typography/Text';
import { FREE_USER_STARTING_CREDITS_DISPLAY } from '@/constants/config';
import { content, getLandingFaqs } from '@/lib/landingPageSeo';
import { GhostCta, Section, useLanding } from './LandingKit';
import { fluid } from './landingTokens';

const FAQS = getLandingFaqs(FREE_USER_STARTING_CREDITS_DISPLAY);

function LandingFaq() {
  const { c, width } = useLanding();
  const compact = width < 850;
  return (
    <Section label="Questions about Gab AI" style={{ borderTopWidth: 1, borderTopColor: c.rule }}>
      <Text tag="h2" weight="semibold" style={{ color: c.ink, fontSize: fluid(width, 30, 42), lineHeight: fluid(width, 36, 48), letterSpacing: -1.2, marginBottom: 36 }}>{content.faqTitle}</Text>
      <View style={{ flexDirection: 'row', flexWrap: 'wrap', columnGap: 48, rowGap: 36 }}>
        {FAQS.map(faq => (
          <View key={faq.question} style={{ width: compact ? '100%' : '46%', flexGrow: 1, borderTopWidth: 1, borderTopColor: c.ruleStrong, paddingTop: 24, gap: 14 }}>
            <Text tag="h3" weight="semibold" style={{ color: c.ink, fontSize: 19, lineHeight: 27, letterSpacing: -0.35 }}>{faq.question}</Text>
            <Text tag="p" style={{ color: c.inkSoft, fontSize: 15, lineHeight: 25 }}>{faq.answer}</Text>
            <GhostCta href={faq.href} label={faq.linkLabel} />
          </View>
        ))}
      </View>
    </Section>
  );
}

export default React.memo(LandingFaq);
